import { useState } from "react";
import { cn } from "@/lib/utils";
import { IconFilm } from "@/components/icons/Icons";

/**
 * Lazy image with blur-up reveal + elegant fallback when the URL is missing/broken.
 */
export function SmartImage({ src, alt = "", className, imgClassName, priority = false, fallbackTitle, variant = "poster", sizes, onLoad, style }) {
  const [state, setState] = useState(src ? "loading" : "error");
  const [prevSrc, setPrevSrc] = useState(src);
  if (src !== prevSrc) {
    setPrevSrc(src);
    setState(src ? "loading" : "error");
  }

  return (
    <div className={cn("relative overflow-hidden bg-[#141418]", className)} style={style}>
      {state === "loading" && <div className="pk-shimmer absolute inset-0" aria-hidden="true" />}
      {state === "error" ? (
        <div className="absolute inset-0 flex flex-col items-center justify-center gap-2 bg-[radial-gradient(120%_80%_at_50%_0%,#1d1d22_0%,#101013_70%)] p-3 text-center" data-testid="image-fallback">
          <IconFilm size={variant === "poster" ? 30 : 40} className="text-white/25" />
          {fallbackTitle && <span className="line-clamp-2 max-w-[90%] text-[12.5px] font-semibold text-white/45">{fallbackTitle}</span>}
        </div>
      ) : (
        <img
          src={src}
          alt={alt}
          sizes={sizes}
          loading={priority ? "eager" : "lazy"}
          decoding="async"
          fetchPriority={priority ? "high" : "auto"}
          referrerPolicy="no-referrer"
          onLoad={(e) => {
            setState("loaded");
            onLoad?.(e);
          }}
          onError={() => setState("error")}
          className={cn(
            "absolute inset-0 h-full w-full object-cover transition-[opacity,transform] duration-500 [transition-timing-function:cubic-bezier(.2,.9,.2,1)]",
            state === "loaded" ? "opacity-100 scale-100" : "scale-[1.03] opacity-0",
            imgClassName
          )}
        />
      )}
    </div>
  );
}
